export const IN_PROGRESS = "IN_PROGRESS";
export const COMPLETED = "COMPLETED";
export const TBD = "TBD";
export const REQUIRED = "REQUIRED";
export const NOT_REQUIRED = "NOT_REQUIRED";
export const VERIFYING = "VERIFYING";
export const VOIDED = "VOIDED";
